<template>
  <div :class="{'english': isenglish ,'japanese': isjapanese ,'footer':true}" :style="{background: colorBg}">
    <div class="foo_style" :style="{background: colorBg2}">
      <div class="footer_style">
        <img src="../assets/img/blue_logo.png" class="cat_style" />
        <div class="foot_right">
          <div class="footer_img_style">
            <!-- <div class="one_style">一般家庭</div> -->
            <!-- <div @click="cat_href_click" class="point_style">天猫店 <img class="footicon" src="../assets/img/footicon.png" alt=""></div>
            <div @click="jd_href_click" class="point_style">京东店 <img class="footicon" src="../assets/img/footicon.png" alt=""></div> -->
          </div>
          <div class="footer_img_style">
            <!-- <div class="one_style">CGM公司</div> -->
            <div @click="operation_href_click" class="point_style">
              运营公司 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
            <div @click="prescription_href_click" class="point_style">
              CGM Medical线上处方 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
            <div @click="prescription_search_href_click" class="point_style">
              全球处方药搜索 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
            <div @click="express_href_click" class="point_style">
              PPROPHARMA Express国际物流 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
          </div>
          <div class="foot_img_style">
            <!-- <div class="one_style">利用规约</div> -->
            <div @click="agreement_href_click" class="point_style">
              CGM会员条款 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
            <div @click="protect_href_click" class="point_style">
              个人信息保护条款 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
            <div @click="site_href_click" class="point_style">
              关于Site利用 <img class="footicon" src="../assets/img/footicon.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="mobile_style">
        <!-- <img src="../assets/img/logo.svg" class="cat_style" /> -->
        <div>
          <el-collapse accordion>
            <el-collapse-item>
              <template slot="title">
                <div class="t_style">CGM GROUP</div>
              </template>
              <!-- <div @click="cat_href_click" class="co_style">
                天猫店 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="jd_href_click" class="co_style">
                京东店 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div> -->
              <div @click="operation_href_click" class="co_style">
                运营公司 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="prescription_href_click" class="co_style">
                CGM Medical线上处方 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="prescription_search_href_click" class="co_style">
                全球处方药搜索 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="express_href_click" class="co_style">
                PPROPHARMA Express国际物流 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
            </el-collapse-item>
            <el-collapse-item style="display: none;">
              <template slot="title">
                <div class="t_style">CGM公司</div>
              </template>
              <div @click="operation_href_click" class="co_style">
                运营公司 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="prescription_href_click" class="co_style">
                CGM Medical线上处方 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="prescription_search_href_click" class="co_style">
                全球处方药搜索 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
              <div @click="express_href_click" class="co_style">
                PPROPHARMA Express国际物流 <img class="footicon" src="../assets/img/footicon.png" alt="">
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="rule_style">
          <div class="">利用规约</div>
          <div @click="agreement_href_click" class="">CGM会员条款</div>
          <div @click="protect_href_click" class="">
            个人信息保护条款
          </div>
          <div @click="site_href_click" class="">关于Site利用</div>
        </div>
      </div>
      <div class="foot_botoutside">
        <img src="../assets/img/blue_logo.png" class="cat_style phonelogo" />
        <div class="foot_bot">
          <div class="foot_botfl">© 2024 CGM GROUP, Inc.</div>
          <div class="foot_botfr">Copyright © CGM Innovation Co., Ltd.</div>
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  cat_href,
  jd_href,
  city_href,
  operation_href,
  prescription_href,
  prescription_search_href,
  express_href,
  agreement_href,
  protect_href,
  site_href,
} from "../assets/config/img";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      // colorBg:'#F5F4F2',
      // colorBg2:'#fFF',
      colorBg:'',
      colorBg2:'',
      isenglish:false,
      isjapanese:false,
    };
   
  },
  mounted() {
    // this.language = window.translate.language.getCurrent();
    // if(this.language == "english"){
    //   this.isenglish = true
    // }
    // if(this.language == "japanese"){
    //   this.isjapanese = true
    // }
    if(this.$route.name =="Firstindex"||this.$route.name =="Pay"){
      this.colorBg = "white",
      this.colorBg2 = "lightcyan"
    }else{
      this.colorBg = "WhiteSmoke",
      this.colorBg2 = "White"
    }
   
  },
  watch: {
    '$route.path'(toPath, fromPath){
            // console.log('路由变化了')
            // console.log('当前页面路由地址：' + toPath)
            // console.log('上一个路由地址：' + fromPath)

            if(toPath =="/Firstindex"||toPath =="/Pay"){
              this.colorBg = "white",
              this.colorBg2 = "lightcyan"
            }else{
              this.colorBg = "WhiteSmoke",
              this.colorBg2 = "White"
            }
         },
        },
  methods: {
    logo_click() {
      if (this.cgmUserVO) {
        let userId = JSON.parse(this.cgmUserVO).userId;
        this.axios
          .get("/cgmOrder/getOrderCount", {
            params: {
              userId,
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.configFlag = res.data.data;
              if(res.data.data > 0){
                this.$router.push("/ConfigMedicine");
              }else{
                this.$router.push("/Firstindex");
              }
            }
          });
        }
      
    },
    login_click() {
      this.$router.push("/Login");
    },
    register_click() {
      this.$router.push("/Register");
    },
    cat_href_click() {
      window.open(cat_href);
    },
    jd_href_click() {
      window.open(jd_href);
    },
    city_href_click() {
      window.open(city_href);
    },
    operation_href_click() {
      window.open(operation_href);
    },
    prescription_href_click() {
      window.open(prescription_href);
    },
    prescription_search_href_click() {
      window.open(prescription_search_href);
    },
    express_href_click() {
      window.open(express_href);
    },
    agreement_href_click() {
      window.open(agreement_href);
    },
    protect_href_click() {
      window.open(protect_href);
    },
    site_href_click() {
      window.open(site_href);
    },
  },
};
</script>
<style lang="scss" >
::v-deep .el-collapse-item__header {
  padding:5px 10px;
    border-radius: 12px;
    box-shadow: 0 3px 4px rgba(0,0,0,.1);
    border-bottom: none;
    position: relative;
    display: block;
}
::v-deep .el-collapse-item__header::before{
  -webkit-backface-visibility: hidden;
  width: 14px;
    position: absolute;
    top: 50%;
    right: 20px;
    height: 1px;
    margin: -1px 0 0;
    background-color: #5c5c5c;
    content: "";
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    transition: -webkit-transform .25s cubic-bezier(.4,0,.2,1) 0s;
    transition: transform .25s cubic-bezier(.4,0,.2,1) 0s;
    transition: transform .25s cubic-bezier(.4,0,.2,1) 0s, -webkit-transform .25s cubic-bezier(.4,0,.2,1) 0s;
}
::v-deep .el-collapse-item__header::after{
  width: 14px;
  -webkit-backface-visibility: hidden;
    position: absolute;
    top: 50%;
    right: 20px;
    height: 1px;
    margin: -1px 0 0;
    background-color: #5c5c5c;
    content: "";
    transition: -webkit-transform .25s cubic-bezier(.4,0,.2,1) 0s;
    transition: transform .25s cubic-bezier(.4,0,.2,1) 0s;
    transition: transform .25s cubic-bezier(.4,0,.2,1) 0s, -webkit-transform .25s cubic-bezier(.4,0,.2,1) 0s;
}
::v-deep .el-collapse-item.is-active .el-collapse-item__header::before{
  -webkit-transform: rotate(0deg);
    transform: rotate(0deg);

}
::v-deep .el-collapse-item__arrow{
  display: none;
}
.el-collapse{
  border:none;
}
::v-deep .el-collapse-item__header.is-active{
  border-radius: 12px 12px 0 0;
  box-shadow: none;
}
::v-deep .el-collapse-item__wrap{
  border-radius: 0 0 12px 12px;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
}
::v-deep .el-collapse-item__content {
  padding: 0 10px 10px 10px;
  font-size: 14px;
}

@media (min-width: 768px) {
  .phonelogo{
    display: none;
  }
  .mobile_style {
    display: none;
  }
  .buttom_style {
    display: none;
  }
}
.co_style {
  margin-bottom: 17px;
}
.t_style {
  font-size: 14px;
  color: #445566;
}
.fo_style {
  display: flex;
  justify-content: space-evenly;
  margin: 20px 0;
}
.one_style {
  font-weight: bold;
  font-size: 14px;
  color: #445566;
  line-height: 3;
}
.point_style {
  cursor: pointer;
  font-size: 16px;
  line-height: 2;
  padding: 8px 0;
  display: inline-block;
  position: relative;
}
.point_style:nth-child(1){
  width: 150px;
}
.point_style:nth-child(2){
  width:210px;
}
.point_style:nth-child(3){
  width: 160px;
}
// .point_style::after{
//   position: absolute;
//   content:'';
//   right:auto;
//   top:16px;
//   width:15px;
//   height: 15px;
//   background: url(../assets/img/footicon.png);
//   background-size: 100% 100%;
// }
.com_style {
  margin-bottom: 32px;
  font-size: 12px;
  color: #778899;
  text-align: center;
}
.head_style {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.head_height_style {
  height: 60px;
}

.head_style1 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}

.head_margin_style {
  margin-right: 20px;
}

.logo_style {
  width: 140px;
  cursor: pointer;
}

.cat_style {
  width: 220px;
  vertical-align: top;
  display: inline-block;
  margin-right: 104px;
}

// .login_style {
//   background: rgb(229, 28, 81);
//   color: #fff;
//   font-weight: bold;
//   border-radius: 100px;
//   padding: 8px 16px;
//   cursor: pointer;
// }

.register_style {
  background: #409eff;
  color: #fff;
  font-weight: bold;
  border-radius: 100px;
  padding: 8px 16px;
  cursor: pointer;
}

.footer_style {
  // display: flex;
  // justify-content: space-evenly;
  // align-items: flex-start;
  margin-bottom: 40px;
  font-size: 0;
}
.footer{
  // background: #F5F4F2;
}
.foo_style {
  // background: #fff;
  box-sizing: border-box;
  width: 1220px;
  margin:0 auto;
  border-radius: 20px 20px 0 0;
  padding: 70px 32px 50px;
}
.footicon{
  width: 15px;
  vertical-align: middle;
}
.foot_right{
  width:calc(100% - 330px);
  display: inline-block;
}
.foot_bot{
  width:90%;
  display: block;
  margin: 0 auto;
  font-size: 16px;
  overflow:auto;
  zoom:1;
}
.foot_botfl{
  float: left;
}
.foot_botfr{
  float: right;
}
 .mobile_style {
    display: none;
  }
  .footicon{
    width:15px;
  }
  
  .cat_style.phonelogo{
    display: none;
  }
@media (max-width: 1250px) {
  .foo_style{
    width: 100%;
    padding:60px 30px 45px;
  }
  .cat_style{
    margin-right: 60px;
  }
  .point_style{
    font-size: 14px;
  }
  .footicon{
    width: 12px;
  }
  .foot_bot{
    padding:0 22px;
    width: 100%;
  }
  .foot_botfr{
    padding-right: 30px;
  }
  .point_style[data-v-40ab164b]:nth-child(1){
    width: 120px;
  }
  .point_style[data-v-40ab164b]:nth-child(2){
    width: 180px;
  }
  .point_style:nth-child(3){
    width: 140px;
  }
}
@media (max-width: 768px) {
  .point_style:nth-child(1){
    width: 120px;
  }
  .footicon{
    margin-top: -2px;
  }
  .point_style:nth-child(3){
    width: 120px;
  }
  .foot_right{
    width: 100%;
    display: block;
  }
  .cat_style {
    width: 40% !important;
    margin:0 0 10px -6px;
    display: block;
  }
  .buttom_seller_style {
    width: 40% !important;
  }
  .foo_style {
    padding: 40px 20px 70px;
  }
  .one_style {
    font-weight: unset !important;
  }
  .point_style {
    margin-bottom: 40px;
    margin-left: 20px;
  }
  .com_style {
    text-align: unset !important;
    margin-bottom: 80px !important;
    margin-top: 24px !important;
  }
  .buttom_style {
    width: 100%;
    height: 77px;
    background: #fff;
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    border-top: 1px solid #e5e9f0;
  }
  .rule_style {
    column-gap: 16px;
    flex-wrap: wrap;
    font-size: 14px;
    line-height: 2;
    // padding: 8px 0;
    margin: 20px 0 35px 0;
    // display: flex;
  }
  .point_style{
    margin-bottom:0px;
    margin-left:0;
    line-height: 1.5;
  }
  .point_style::after{
    width: 12px;
    height: 12px;
    right:-20px;
  }
  .foot_bot{
    padding:0;
  }
  .foot_botfl{
    display: block;
    float: none;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .foot_botfr{
    padding-right: 0;
    float: none;
    font-size: 14px;
  }
  .footer_style{
    display: none;
    margin-bottom: 20px;
  }
  .foot_botoutside{
    overflow:auto;
     zoom:1;
  }
  .phonelogo{
    display: block;
    float: left;
  }
  .cat_style.phonelogo{
    display: block;
    width: 100px!important;
  }
  .foot_bot{
    float: right;
    width:calc(100% - 120px);
  }
  .mobile_style{
    display: block;
  }
}
// 英文
.english{
  .cat_style{
      margin-right: 38px;
  }
  .foot_right{
      width:calc(100% - 270px);
  }
  .point_style{
      font-size: 13px;
  }
  .point_style:nth-child(1){
      width: 175px;
  }
  .point_style:nth-child(2){
      width: 265px;
  }
  .point_style:nth-child(3){
      width: 220px;
  }

 @media (max-width: 768px) {
  .cat_style{
    margin-right: 24px;
  }
 }
}
// 日文
.japanese{
  .cat_style{
      margin-right: 50px;
  }
  .foot_right{
      width:calc(100% - 270px);
  }
  .point_style{
      font-size: 14px;
  }
  .point_style:nth-child(1){
      width: 165px;
  }
  .point_style:nth-child(2){
      width: 255px;
  }
  .point_style:nth-child(3){
      width: 190px;
  }
  @media (max-width: 768px) {
  .cat_style{
    margin-right: 24px;
  }
 }
}
</style>